import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "uk-container-large uk-margin-top border-outline" }
const _hoisted_2 = {
  class: "uk-grid-small",
  "data-uk-grid": ""
}
const _hoisted_3 = { class: "uk-margin uk-width-1-1@s uk-width-1-2@l uk-width-1-2@xl uk-form-controls" }
const _hoisted_4 = { class: "uk-inline" }
const _hoisted_5 = { class: "uk-width-1-1@s uk-width-1-2@l uk-width-1-2@xl" }

import {getCurrentInstance, ref} from "vue";
import {useStore} from "vuex";
  
export default /*@__PURE__*/_defineComponent({
  __name: 'OldCustomer',
  emits: ['customerFound'],
  setup(__props, { emit: __emit }) {

const { $alert } = getCurrentInstance().appContext.config.globalProperties;
  const { $axios } = getCurrentInstance().appContext.config.globalProperties;
  const { $endpoint } = getCurrentInstance().appContext.config.globalProperties;
  const emit = __emit
  const store = useStore()
  const contactSearch = ref(store.getters['booking/getCustomer']?.cust_contact)
  const checkCustomerInfos = ()=>{
    if (contactSearch.value.length ===10){
      $axios.get($endpoint.CheckCustomerInfosByContact(contactSearch.value)).then((resp_cust:any)=>{
        store.dispatch('booking/saveCustomer', resp_cust.data.data)
        store.dispatch('booking/saveNewCustomer',false)
        emit('customerFound')
      }).catch((err:any)=>{
        console.log(err)
      })
    }else {
      $alert.fire({
        title: 'Ooops!',
        text: "Veuillez renseigné un contact correct (10 chiffres)",
        icon: 'error',
        confirmButtonColor:'#D62F2F',
        confirmButtonText: 'Compris'
      })

    }
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[3] || (_cache[3] = _createElementVNode("h6", { class: "uk-heading-line uk-text-center uk-text-secondary uk-text-uppercase uk-text-bold" }, [
      _createElementVNode("span", null, "Vérifier votre enregistrement à partir de votre contact ")
    ], -1)),
    _createElementVNode("form", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[2] || (_cache[2] = _createElementVNode("span", {
            class: "uk-form-icon uk-form-icon-flip",
            "uk-icon": "icon: phone"
          }, null, -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((contactSearch).value = $event)),
            class: "uk-input uk-input uk-form-width-large uk-border-rounded csa-input",
            placeholder: "Contact pendant l'enregistrement",
            type: "text",
            "aria-label": "Not clickable icon"
          }, null, 512), [
            [_vModelText, contactSearch.value]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          type: "button",
          class: "uk-button csa-btn",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (checkCustomerInfos()))
        }, "Rechercher")
      ])
    ])
  ]))
}
}

})